export default {
  TEMP: 1,
  PROSPECT: 2,
  CLIENT: 3,
  OLD_CLIENT: 4,
  LOST_CLIENT: 5,
  BANNED_CLIENT: 6,
};
